import styled from 'styled-components';

export const Container = styled.div`
  bottom: 95px;
  position: absolute;
  right: 190px;
  width: 409px;
  z-index: 3;

  @media (min-width: 1024px) {
    right: 100px;
  }

  @media (max-width: 1023px) {
    bottom: calc(100vh - 600px);
    right: calc(50% - 250px);
    width: 500px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 30%;
    right: 50px;
    bottom: 90px;
  }
  @media (max-width: 767px) {
    bottom: 360px;
    right: 30px;
    width: calc(100% - 60px);
  }

  @media (min-width: 320px) and (max-width: 766px) {
    display: none;
  }
`;

export const Dot = styled.span`
  background: #1277c6;
  border-radius: 50%;
  display: block;
  height: 45px;
  left: 50%;
  margin-left: -22.5px;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  position: absolute;
  transform-origin: center center;
  transition: all 400ms ease-in;
  width: 45px;

  ::after {
    background: #fff;
    border-radius: 50%;
    content: '';
    display: block;
    height: 15.5px;
    left: 50%;
    margin: -7.75px 0 0 -7.75px;
    position: absolute;
    top: 50%;
    width: 15.5px;
  }
`;

export const OuterFrame = styled.div`
  border: 1px solid #fff;
  height: 370px;
  margin-bottom: 6px;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  position: relative;
  transform: ${(props) => (props.visible ? 'scale(1)' : 'scale(0.3)')};
  transform-origin: center bottom;
  transition: all 400ms ease-in-out 500ms;
  width: 100%;
  z-index: 2;

  ::after {
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 16px solid #fff;
    bottom: -16px;
    content: '';
    display: block;
    font-size: 0;
    height: 0;
    line-height: 0;
    margin-left: -13px;
    position: absolute;
    left: 50%;
    width: 0;
    z-index: 2;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    height: 250px;
  }

  @media (min-width: 320px) and (max-width: 766px) {
    height: 0px;
  }
`;

export const HeartIcon = styled.span`
  background: #fff url('/public-assets/images/dream-to-reality/heart-icon.svg')
    center 5px no-repeat;
  background-size: auto 22.5px;
  border-radius: 50%;
  display: block;
  height: 28px;
  position: absolute;
  right: 9px;
  top: 9px;
  width: 28px;
`;

export const InnerContainer = styled.div`
  background: #fff;
  bottom: 0;
  box-sizing: border-box;
  color: #25292d;
  display: flex;
  height: 130px;
  justify-content: space-between;
  left: 0;
  padding: 20px;
  position: absolute;
  width: 100%;

  @media (min-width: 768px) and (max-width: 1023px) {
    height: 100px;
    padding: 5px 5px;
  }

  @media (max-width: 375px) {
    padding: 15px;
    height: 100px;
  }

  @media (max-width: 320px) {
    height: 90px;
  }
`;

export const Info = styled.ul`
  font-size: 16px;
  margin: 0;
  padding: 0;

  li {
    font-weight: 500;
    list-style: none;
    line-height: normal;
  }

  li:first-of-type {
    font-size: 24px;
    font-weight: 500;
    padding-bottom: 10px;
  }

  @media (max-width: 767px) {
    li:first-of-type {
      padding-bottom: 16px;
    }
  }

  @media (max-width: 450px) {
    li:first-of-type {
      padding-bottom: 16px;
    }
    li {
      line-height: 25px;
    }
  }

  @media (max-width: 450px) and (min-height: 812px) {
    li:first-of-type {
      padding-bottom: 16px;
    }
  }

  @media (max-width: 375px) {
    font-size: 12px;
    li:first-of-type {
      font-size: 18px;
    }
    li {
      line-height: 20px;
    }
  }

  @media (max-width: 375px) and (max-height: 811px) {
    li:first-of-type {
      padding-bottom: 10px;
    }
  }

  @media (max-width: 320px) {
    li:first-of-type {
      font-size: 18px;
      padding-bottom: 14px;
    }
    li {
      font-size: 15px;
      line-height: 16px;
    }
  }
`;

export const Acreage = styled.small`
  color: #1277c6;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
`;
